import type { AuthContextValue } from '@platform/auth-client';

export type RouterContext = { auth: AuthContextValue };

export const SUPER_ADMIN_ROLE = 'super-admin';
